import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();

  return (
    <div className="fixed top-6 right-6 z-[100] flex gap-2">
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setLang('en')}
        className={`px-3 py-1.5 rounded-sm text-[10px] font-bold tracking-widest uppercase transition-all duration-300 border ${
          lang === 'en' 
            ? 'bg-brand-accent text-white border-brand-accent shadow-lg' 
            : 'bg-white/80 backdrop-blur-md text-brand-dark border-brand-muted/30 hover:border-brand-accent'
        }`}
      >
        EN
      </motion.button>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setLang('es')}
        className={`px-3 py-1.5 rounded-sm text-[10px] font-bold tracking-widest uppercase transition-all duration-300 border ${
          lang === 'es' 
            ? 'bg-brand-accent text-white border-brand-accent shadow-lg' 
            : 'bg-white/80 backdrop-blur-md text-brand-dark border-brand-muted/30 hover:border-brand-accent'
        }`}
      >
        ES
      </motion.button>
    </div>
  );
}